// extracted by mini-css-extract-plugin
export default {"dragging":"_1kd6q"};